import { mapActions } from 'vuex'

export default {
    template: '<router-view />',

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.setShowLoading()
            vm.fetchPriceRange()
            vm.fetchProduct({page:1}).then(()=>{
                vm.setShowLoading(false)
            })
        })
    },
    beforeRouteLeave (to, from, next) {
        this.resetProduct()
        next()
    },

    methods: {
        ...mapActions({
            fetchPriceRange: 'product/fetchPriceRange',
            fetchProduct: 'product/fetch',
            resetProduct: 'product/resetProduct',
            setShowLoading: 'loadingComponent/setShowLoading',
        }),
    }
}